import React from 'react'

export interface IVolumesStepperIconProps {
  iconName: string
}

export const VolumesStepperIcon: React.FC<IVolumesStepperIconProps> = ({
  iconName,
}: IVolumesStepperIconProps) => <img src={iconName} width="22" />
